import LivePriceBox from "@/elements/LivePriceBox/LivePriceBox";
import NseOrBsePrice from "@/elements/NseOrBsePrice/NseOrBsePrice";
import { getForGttOrderStatus, getForRegularOrderStatus } from "@/lib/placeOrder";
import { resetStocksDetails, updateDataFromSocket, updateStocksDetails } from "@/store/features/stocksDetailsSlice";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import WatchListButton from "../PaidUsers/WatchListButton";
import { Button } from "../ui/button";
import trade_idea_rounded_icon from "@/assets/icons/Icon.svg";
import Image from "next/image";
import TradeCardBF from "../PlaceOrder/TradeCardBF";
import { IoMdClose } from "react-icons/io";
import { IoInformationCircle } from "react-icons/io5";

export default function StockDetailsHeader({ trade }) {
    const dispatch = useDispatch();
    const { scripData, finCode, stockDetails, orderDetails, gttDetails, positionsDetails, holdingDetails } =
        useSelector((state) => state.stocksDetails);

    var details = orderDetails?.status
        ? orderDetails
        : gttDetails?.status
        ? gttDetails
        : holdingDetails?.smAdditionalDetailDto
        ? holdingDetails
        : positionsDetails;
    const pageName = orderDetails?.status ? "order_info_bf" : gttDetails?.status ? "gtt_info_bf" : "positions_info_bf";

    const renderStatus = (status, txnType, remarks) => {
        return (
            <>
                {status && (
                    <div
                        className={`px-2 py-[1.5px] flex justify-center items-center rounded font-bold bg-white text-[10px]`}
                        style={{
                            color: orderDetails?.status
                                ? getForRegularOrderStatus(status)?.[2]
                                : getForGttOrderStatus(status)?.[2],
                            backgroundColor: `${
                                orderDetails?.status
                                    ? getForRegularOrderStatus(status)?.[2]
                                    : getForGttOrderStatus(status)?.[2]
                            }21`
                        }}
                    >
                        {orderDetails?.status
                            ? getForRegularOrderStatus(status)?.[1]
                            : getForGttOrderStatus(status)?.[1]}
                    </div>
                )}
                {txnType && (
                    <div
                        className={`border px-2 flex justify-center items-center rounded font-bold bg-white text-[10px] ${
                            txnType === "B" ? "border-[#26A649] text-[#26A649]" : "border-[#EB4E2C] text-[#EB4E2C]"
                        }`}
                    >
                        {txnType === "B" ? "Buy" : "Sell"}
                    </div>
                )}
                {remarks && (
                    <TradeCardBF
                        tradeId={remarks}
                        pageName={
                            orderDetails?.status
                                ? "order_regular_bf"
                                : gttDetails?.status
                                ? "order_gtt_bf"
                                : "positions_info_bff"
                        }
                    >
                        <Image
                            src={trade_idea_rounded_icon}
                            alt="trade_idea_rounded_icon"
                            className="w-[18px] h-[18px]"
                        />
                    </TradeCardBF>
                )}
            </>
        );
    };

    return (
        <div className="font-Inter pt-6 sticky top-0 z-10 bg-white shadow-[0px_0px_8px_0px_rgba(0,0,0,0.1)]">
            <div className="flex flex-row items-center mr-4">
                <Button variant="icon" className="min-w-6 pl-2" onClick={() => dispatch(resetStocksDetails())}>
                    <IoMdClose size={24} />
                </Button>
                <div>
                    <div className="font-extrabold text-sm text-black">
                        {stockDetails?.title ?? stockDetails?.nseSymbol ?? stockDetails?.bseSymbol}
                    </div>
                    <div className="font-medium text-sm text-[#606060] line-clamp-1 pr-4">
                        {stockDetails?.subtitle ?? stockDetails?.compName}
                    </div>
                </div>
                <div className="ml-auto">
                    <LivePriceBox ltpPrice={trade?.ltp} textClass="font-bold text-base text-black text-right" />
                    <NseOrBsePrice
                        isIcon={true}
                        nseLtpPrice={trade?.ltp}
                        nseClosePrice={stockDetails?.nseClosePrice ?? stockDetails?.bseClosePrice}
                        textClass="mt-0.5 text-xs font-semibold text-right whitespace-nowrap"
                    />
                </div>
            </div>
            <div className="p-4 flex flex-row items-center gap-1.5">
                <div className="text-xs font-semibold text-[#606060]">
                    {details?.mainExchange ?? scripData?.exchange}
                </div>
                {details?.productTag && (
                    <div
                        className={`px-2 py-[1.5px] flex justify-center items-center rounded font-bold bg-[#ECF6FE] text-[#0862BC] text-[10px]`}
                    >
                        {details?.productTag}
                    </div>
                )}
                {renderStatus(
                    details?.status,
                    details?.txn_type,
                    orderDetails?.status ? details?.trade_card_id : details?.remarks ?? details?.tradeCardId
                )}
                <WatchListButton
                    className="w-5 h-5 ml-auto"
                    watchListIds={stockDetails?.watchlistList ?? []}
                    finCode={finCode}
                    exchange={details?.mainExchange ?? details?.exchange}
                    size="19px"
                    pageName={pageName}
                    symbol={stockDetails?.nseSymbol ?? stockDetails?.bseSymbol}
                />
            </div>
            {orderDetails?.status && getForRegularOrderStatus(orderDetails?.status)[1] === "ON-HOLD" && (
                <>
                    <hr className="mx-4" />
                    <div className="my-2 mx-4 px-3 py-1.5 bg-[#ECF6FE] flex items-center gap-2 rounded">
                        <IoInformationCircle color="#00439D" className="min-w-[12px]" />
                        <div className="text-[10px] text-[#00439D] font-bold">
                            Order is kept on hold due till the parent order is executed.
                        </div>
                    </div>
                </>
            )}
            {orderDetails?.status && getForRegularOrderStatus(orderDetails?.status)[1] === "REJECTED" && (
                <>
                    <hr className="mx-4" />
                    <p className="flex-[1_0_0] p-4 text-[#EB4E2C] text-center text-xs font-medium leading-5">
                        {orderDetails?.reason_description}
                    </p>
                </>
            )}
        </div>
    );
}
